import { render, staticRenderFns } from "./BrandCopyright.vue?vue&type=template&id=aac8f942"
var script = {}
import style0 from "./BrandCopyright.vue?vue&type=style&index=0&id=aac8f942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports